import React, { useState, useRef, useEffect } from 'react';
import { Estruturas, Loader } from "../index";
import { Col, Row } from "reactstrap";
import { MenuTable } from '../../Menu';
import { iniciarValorPadrao, create_UUID } from '../funcoes';
import { axiosApi } from '../axiosInstances';
import ModalAtualizarAula from '../../Modal/ModalAtualizarAula';
import { connect } from 'react-redux';
import * as actionsRedux from '../../Store/Actions/index';

const GerarEstrutura = ({
    iconAdicionar,
    iconRemover,
    iconSalvar,
    iconRemoverLocal,
    estruturaPadrao,
    valorPadrao,
    submit,
    formularioGeral,
    adicionarOnClick,
    salvarLocal,
    removerLocal,
    removerOnClick,
    onChangeEstrutura,
    name,
    versaoOpcoes,
}) => {
    return (
        <Col xs={12} className={`replicar-form-linha-wrap replicar-form-linha-wrap-${name}`}>
            <Row className={`replicar-form-linha replicar-form-linha-${name}`}>
                <Col xs={9} sm={10} md={10} lg={11} xl={11} className={`replicar-form-campos replicar-form-campos-${name}`}>
                    <Row>
                        <Estruturas
                            // `Estruturas` é um componente de classe que copia as opções de
                            // cada select pro seu `state` só na construção e nunca mais
                            // sincroniza com props novas — sem essa `key` mudando, a busca
                            // dinâmica de opções (acima) nunca aparecia na tela, mesmo com a
                            // resposta certa já chegando.
                            key={`estrutura-${versaoOpcoes}`}
                            estrutura={iniciarValorPadrao(estruturaPadrao, valorPadrao)}
                            submit={submit}
                            formularioGeral={formularioGeral}
                            onChange={onChangeEstrutura}
                        />
                    </Row>
                </Col>
                <Col xs={3} sm={2} md={2} lg={1} xl={1} className={`replicar-form-icones replicar-form-icones-${name}`}>
                    <MenuTable
                        iconRemover2={iconRemover}
                        iconAdicionar={iconAdicionar}
                        iconSalvar={iconSalvar}
                        iconRemoverLocal={iconRemoverLocal}
                        removerOnClick={removerOnClick}
                        adicionarOnClick={adicionarOnClick}
                        salvarLocal={salvarLocal}
                        removerLocal={removerLocal}
                        containerStyle={{ height: '100%' }}
                    />
                </Col>
            </Row>
        </Col>
    );
};

const ReplicarForm = ({
    ativar,
    name,
    estruturaPadrao,
    submit,
    onChange,
    valorAtual,
    formularioGeral,
    valorPadrao = [{}]
}) => {
    const [quantidadeDeEstrutura, setQuantidadeDeEstrutura] = useState(valorPadrao.length === 0 ? 1 : valorPadrao.length);
    const formulario = useRef(valorPadrao.length === 0 ? [{}] : valorPadrao);
    const estruturas = [];
    const [modalAtualizacao, setModalAtualizacao] = useState(false);
    const [indiceModal, setIndiceModal] = useState();
    const [loader, setLoader] = useState(false);
    const [opcoesDinamicas, setOpcoesDinamicas] = useState({});
    const [versaoOpcoes, setVersaoOpcoes] = useState(0);

    // Alguns campos de `estruturaPadrao` podem pedir opções que dependem de campos-irmãos do
    // formulário (ex.: "Letra" só deve listar o que ainda não foi usado por OUTRA turma no
    // mesmo período+semestre). Isso é resolvido aqui, buscando direto — de propósito NÃO
    // usamos o mecanismo genérico de "callback" do formulário (Estruturas/atualizarEstrutura),
    // porque ele reseta os dados já digitados nas linhas quando um campo-irmão muda.
    const camposComOpcoesDinamicas = estruturaPadrao.filter(campo => campo.opcoesDinamicasUrl);

    useEffect(() => {
        if (!camposComOpcoesDinamicas.length || !formularioGeral) return;

        camposComOpcoesDinamicas.forEach(campo => {
            const params = (campo.opcoesDinamicasParams || []).reduce((acc, chave) => {
                acc[chave] = formularioGeral[chave];
                return acc;
            }, {});

            if (Object.values(params).some(valor => valor === undefined || valor === null || valor === '')) {
                return;
            }

            axiosApi.get(campo.opcoesDinamicasUrl, { params })
                .then(({ data }) => {
                    setOpcoesDinamicas(anterior => ({ ...anterior, [campo.name]: data.options }));
                    setVersaoOpcoes(anterior => anterior + 1);
                })
                .catch(() => { });
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, (camposComOpcoesDinamicas[0]?.opcoesDinamicasParams || []).map(chave => formularioGeral?.[chave]));

    // Além de excluir o que já foi usado por OUTRAS turmas (via opcoesDinamicas, buscado no
    // efeito acima), cada linha também precisa excluir o que já foi escolhido nas linhas
    // IRMÃS deste mesmo formulário (senão dá pra repetir a letra duas vezes só de olhar pra
    // linhas que ainda não foram salvas). Isso é recalculado a cada render a partir de
    // `formulario.current`, então sempre reflete o que está preenchido nas outras linhas nesse
    // exato momento.
    const estruturaPadraoParaLinha = (indiceLinha) => {
        if (!camposComOpcoesDinamicas.length) return estruturaPadrao;

        const usadosPorIrmas = formulario.current
            .filter((linha, i) => i !== indiceLinha)
            .map(linha => linha?.grupo_id)
            .filter(valor => valor !== undefined && valor !== null);

        return estruturaPadrao.map(campo => {
            if (!campo.opcoesDinamicasUrl) return campo;

            const opcoesBase = opcoesDinamicas[campo.name] || campo.options;
            return { ...campo, options: opcoesBase.filter(opcao => !usadosPorIrmas.includes(opcao.value)) };
        });
    };

    const adicionarOnClick = () => {
        formulario.current.push({});
        setQuantidadeDeEstrutura(quantidadeDeEstrutura + 1);
    }

    const removerOnClick = (indice) => {
        formulario.current.splice(indice, 1);
        setQuantidadeDeEstrutura(quantidadeDeEstrutura - 1);

        if (valorAtual) {
            onChange(name, formulario.current.slice());
        }
    };

    const removerOnClickLocal = async (indice) => {
        try {
            setLoader(true);
            await axiosApi.delete(`/auxiliares/local-semestre?semestre_id=${formulario.current[indice].semestre_id}&tipo_atividade_id=${formulario.current[indice].tipo_atividade_id}&turma=${formulario.current[indice].turma}`, formulario.current[indice]);
            adicionarOnClick();
            ativar(201, 'Local removido com sucesso.')
            removerOnClick(indice);
        } catch (error) {
            ativar(400, 'Algo deu errado.')
        } finally {
            setLoader(false);
            setModalAtualizacao(false);
        }
    }

    const salvarLocal = (indice) => {
        setLoader(true);
        setIndiceModal(indice)
        setModalAtualizacao(true);
    }

    const atualizarAula = async (atualizaHoje) => {
        try {
            var dados = {
                ...formulario.current[indiceModal],
                abreviatura_curso: formularioGeral.abreviatura,
                atualiza_hoje: atualizaHoje
            }
            await axiosApi.post(`/auxiliares/local-semestre`, dados);
            ativar(201, 'Local adicionado com sucesso.')
            adicionarOnClick();
        } catch (error) {
            ativar(400, 'Algo deu errado.')
        } finally {
            setModalAtualizacao(false);
            setLoader(false);
        }
    }

    const retornarKeyEstrutura = (indice) => {
        formulario.current[indice].componentId = formulario.current[indice].componentId ? formulario.current[indice].componentId : create_UUID();
        return formulario.current[indice].componentId;
    };

    const onChangeEstrutura = (formularioEstrutura, formularioIncompleto, indice, invalidar) => {
        if (formularioIncompleto) {
            onChange(name, "");
            // dispatch();
        } else {
            formulario.current[indice] = { componentId: formulario.current[indice].componentId, ...formularioEstrutura };
            onChange(name, formulario.current.slice());
        }

        //TODO: Algoritmo para invalidar aqui
        if (formularioEstrutura && formularioEstrutura['inicio'] === '12:22') {
            invalidar('dia_da_semana')
            invalidar('inicio')
        }
    };

    for (let indice = 0; indice < quantidadeDeEstrutura; indice++) {
        let iconAdicionar = quantidadeDeEstrutura === indice + 1;
        let iconRemover = quantidadeDeEstrutura !== indice - 1;
        estruturas.push(
            <GerarEstrutura
                estruturaPadrao={estruturaPadraoParaLinha(indice)}
                valorPadrao={formulario.current[indice]}
                submit={submit}
                indice={indice}
                name={name}
                iconRemover={name == "locais" || name == "horarios" || name == "atividades" ? false : iconRemover}
                iconRemoverLocal={name == "locais" ? true : false}
                iconAdicionar={name == "horarios" || name == "atividades" ? false : iconAdicionar}
                iconSalvar={name == "locais" ? true : false}
                removerOnClick={() => removerOnClick(indice)}
                adicionarOnClick={adicionarOnClick}
                salvarLocal={() => salvarLocal(indice)}
                removerLocal={() => removerOnClickLocal(indice)}
                formularioGeral={formularioGeral}
                onChangeEstrutura={(formularioEstrutura, incompleto, formularioIncompleto, invalidar) => onChangeEstrutura(formularioEstrutura, formularioIncompleto, indice, invalidar)}
                versaoOpcoes={versaoOpcoes}
                key={retornarKeyEstrutura(indice)}
            />
        );
    };

    return (
        <>
            {loader && <Loader overlay={true} />}
            <ModalAtualizarAula isOpen={modalAtualizacao} atualizarAula={atualizarAula} />
            <Col sm={12} className={`replicar-form-container replicar-form-container-${name}`}>
                <Row>{estruturas}</Row>
            </Col>
        </>
    );
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        ativar: (tipo, acao) => dispatch(actionsRedux.ativarAlert(tipo, acao)),
    }
}
export default connect(null, mapDispatchToProps)(ReplicarForm)